import React from 'react';
import { Check, Circle, AlertCircle, Heart } from 'lucide-react';
import { cn } from '../../lib/utils';

interface TimelineNodeProps {
  type: 'completed' | 'pending' | 'overdue' | 'wedding';
  size?: 'small' | 'medium' | 'large';
}

const TimelineNode: React.FC<TimelineNodeProps> = ({
  type,
  size = 'medium'
}) => {
  const nodeConfig = {
    completed: { 
      color: 'bg-green-500', 
      icon: Check,
      borderColor: 'border-green-200' 
    },
    pending: { 
      color: 'bg-wedding-pink', 
      icon: Circle,
      borderColor: 'border-wedding-pink/30' 
    },
    overdue: { 
      color: 'bg-red-500', 
      icon: AlertCircle,
      borderColor: 'border-red-200' 
    },
    wedding: { 
      color: 'bg-wedding-gold', 
      icon: Heart,
      borderColor: 'border-wedding-gold/30' 
    }
  };
  
  const sizeClasses = {
    small: 'w-3 h-3',
    medium: 'w-4 h-4', 
    large: 'w-6 h-6'
  };
  
  const iconSizeClasses = {
    small: 'w-1.5 h-1.5',
    medium: 'w-2 h-2',
    large: 'w-3 h-3'
  };
  
  const config = nodeConfig[type];
  const IconComponent = config.icon;
  
  return (
    <div 
      className={cn(
        "timeline-node",
        "absolute left-0 top-6 -translate-x-1/2",
        "border-4 border-white rounded-full shadow-lg",
        "flex items-center justify-center",
        "transition-colors duration-200 ease-in-out",
        config.color,
        config.borderColor,
        sizeClasses[size],
        type === 'overdue' && 'animate-pulse'
      )}
    >
      <IconComponent className={cn("text-white", iconSizeClasses[size])} />
    </div>
  );
};

export default TimelineNode;